<template>
  <div>
    <div class="row">
      <transition name="view" appear enter-active-class="animated fadeIn delay">
        <div class="col-md-12">
          <add-document @send-file="sendFile"></add-document>
          <progress-bar :value="progressValue"></progress-bar>
        </div>
      </transition>
    </div>
    <div class="row">
      <div class="col-md-12">
        <transition v-if="dataShown" name="view" appear enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown">
          <table-files :files="files" @delete-file="deleteDocument"></table-files>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
    import AddDocument from "../components/AddDocument";
    import ProgressBar from "../components/Progress";
    import axios from "axios";
    import {setCookie, url} from "../plugins/axios";
    import NotificationTemplate from "./Notifications/NotificationTemplate";
    import TableFiles from "./SafetyDocs/TableFiles";
    export default {
      name: "SafetyDocs",
      components: {ProgressBar, TableFiles, AddDocument},
      data(){
        return{
          files: {},
          dataShown: false,
          progressValue: 0,
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        getFiles(){
          axios
            .get(url + 'documents/0/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.files = response.data.result;
                if (this.files !== null){this.dataShown = true;}
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        sendFile(file){
          let formData = new FormData(document.getElementById('upLoadFile'));
          file.type = 'documents';
          formData.append('site_name',   'safety');
          formData.append('currentDate', file.date);
          formData.append('description', file.description);
          formData.append('file',        file.file);
          formData.append('fileType',    file.type);
          if (file.file !==''){
            axios
              .post(url + 'upload-file/',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  },
                  withCredentials:'include',
                  crossDomain:true,
                })
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success', 'The file was added');
                  this.getFiles();
                }
                else{
                  if (response.data.error === 'Session is over'){
                    setCookie('Authentication','Failed',1);
                    this.$router.push('/login');
                  }
                  else{
                    this.notifyVue('danger',response.data.error);
                  }
                }
              })
              .catch((error) => {
                this.notifyVue('danger',error);
              });
          }
          else{
            this.notifyVue('info','You did not choose the file :(');
          }
        },
        deleteDocument(id, rowId){
          id = parseInt(id);
          axios
            .put(url + 'delete-documents/' + id + '/',
              {data: {}},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                $(this.$el).find(rowId).hide();
                this.notifyVue('success','Document was deleted');
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) =>{
              this.notifyVue('danger',error);
            })
        },
      },
      created() {
        this.getFiles();
      }
    }
</script>

<style scoped>

</style>
